var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[_c('TopPanel',{attrs:{"tabs":[
      { label: 'Caracterización', path: '/caracterizacion/' },
      { label: 'Rating', path: '/rating/' },
      { label: 'Materia prima', path: '/materiaprima/' }
    ]},on:{"year-changed":_vm.onYearChanged}}),_c('div',{staticClass:"mt-4",attrs:{"id":"body"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{staticClass:"rounded",staticStyle:{"height":"80vh"},attrs:{"flat":""}},[_c('v-row',[_c('v-col')],1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }